__turbopack_context__.v({
  "root": "DetailsSectionGreyContentContainer-module-scss-module__FYJn3a__root",
});
